module.exports = __webpack_public_path__ + "static/media/campusImgB.c524f1c6.jpg";